import * as Models from '@rw1/models'
import * as DTO from '@rw1/auto-generated-clients/generated/content-delivery-v2/dto.generated'
import { injectable } from 'inversify'
import { IContentDeliveryMapper } from './IContentDeliveryMapper'

@injectable()
export class ContentDeliveryMapper implements IContentDeliveryMapper {
  toRoomModel(dto: DTO.RoomMetadata): Models.Room {
    return {
      contentMetadataId: dto.contentMetadataId,
      roomMetadataId: dto.roomMetadataId,
      companyId: dto.companyId,
      roomName: dto.roomName,
      mapPath: dto.mapPath,
      allowUserFiles: dto.allowUserFiles,
      allowSinglePlayer: dto.allowSinglePlayerMode,
      description: dto.description,
      isAugmentedRealityCompatible: dto.isAugmentedRealityCompatible,
      isCreatableByExternalUsers: dto.isCreatableByExternalUsers,
      isHub: dto.isHub,
      isSinglePlayer: dto.isSinglePlayer,
      isVisibleInMenu: dto.isVisibleInMenu,
      libraryCardUrl: dto.libraryCardUrl,
      libraryHeroUrl: dto.libraryHeroUrl,
      maxUsers: dto.maxUsers,
      maxVisibility: this.toVisibilityModel(dto.maxVisibility),
      notificationIconUrl: dto.notificationIconUrl,
      replayRecordingType: dto.replayRecordingType,
      tagName: dto.tagName,
    }
  }

  toSpotlightModel(dto: DTO.Spotlight): Models.Spotlight {
    return {
      contentSize: dto.contentSize,
      order: dto.order,
      room: this.toRoomModel(dto.roomMetadata),
      spotlightId: dto.spotlightId,
    }
  }

  toVisibilityModel(dto: DTO.VisibilityType): Models.Visibility {
    switch (dto) {
      case DTO.VisibilityType.Public:
        return Models.Visibility.Public
      case DTO.VisibilityType.Private:
        return Models.Visibility.Private
      case DTO.VisibilityType.Internal:
        return Models.Visibility.Internal
      default:
        throw new Error(`Unknown visibility type: ${dto}`)
    }
  }
}
